/**
 * Decorative solar disc inside two measured rings, cropped by its container's edge.
 * Used by the "Sobriété" bento cell (day) and the contact confirmation (dusk).
 * Pure CSS shapes, hidden from assistive tech. Size and position come from the caller
 * (absolutely positioned inside a box that clips it).
 */
export function SolarDisc({ className = '', tone = 'day' }: { className?: string; tone?: 'day' | 'dusk' }) {
	const outer = tone === 'day' ? 'border-graphite/[0.07] dark:border-mineral/[0.08]' : 'border-mineral/[0.08]';
	const inner = tone === 'day' ? 'border-graphite/10 dark:border-mineral/[0.12]' : 'border-mineral/[0.12]';
	return (
		<div aria-hidden className={`pointer-events-none absolute aspect-square ${className}`}>
			<span className={`absolute inset-0 rounded-full border ${outer}`} />
			<span className={`absolute inset-[16%] rounded-full border ${inner}`} />
			<span data-sun className="absolute inset-[32%] rounded-full bg-solar" />
		</div>
	);
}
